import React, { useState, useContext } from "react";
import { Button, CardImg } from "reactstrap";
import {
  Card,
  CardImgContainer,
  CardProductCheck,
  CardProductCode,
  CardProductName,
} from "./style";
import { Card as ReactStrapCard } from "reactstrap";
import { Link } from "react-router-dom";
import { isBrowser } from "react-device-detect";
import { Notification } from "../common/style";

const Product = (props) => {
  const { dimensions = { height: "", width: "", depth: "" } } = props;
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [notificationMessage, setNotificationMessage] = useState({
    type: "",
    message: "",
  });
  const [hover, setHover] = useState(false);
  const imageUrl =
    hover && props.images.length > 1 ? props.images[1] : props.images[0];

  const getCatalogsUrl = () => {
    const searchQuery = searchParams.get("search");

    if (!searchQuery) return "cutlist";

    return `cutlist?search=${searchQuery}`;
  };

  const handleMouseEnter = () => {
    setHover(true);
  };

  const handleMouseLeave = () => {
    setHover(false);
  };

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const copySubModule = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (props.modulesCategory && props.handleCopyTemplate) {
      props.handleCopyTemplate(
        props.id,
        props.modulesCategory === "internal_submodule"
      );
    }
  };

  return isBrowser || props.action === "cutlist" ? (
    <>
      {notificationMessage.type && (
        <Notification
          color={notificationMessage.type === "error" ? "danger" : "success"}
          isOpen={isNotificationVisible}
          toggle={onDismissNotification}
        >
          {notificationMessage.message}
        </Notification>
      )}
      <div
        className={`${
          props.modulesCategory ? "col-6" : "col-3"
        } position-relative`}
      >
        {props.addedProducts.find((e) => e.id == props.id) && (
          <CardProductCheck onClick={() => props.addProduct(props.product)}>
            <i className="fa-solid fa-check" />
          </CardProductCheck>
        )}
        <Card
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={(e) => {
            if (props.modulesCategory) copySubModule(e);
            else if (props.catalogType && props.catalogSubType)
              props.changeTemplate({
                projectId: props.projectId,
                orderItemId: props.orderItemId,
                productId: props.id,
                dimensionsRange: props.productDimensionsRange,
              });
            else props.addProduct(props.product);
          }}
          className={`module-card ${
            props.modulesCategory && "sub-module-container"
          } ${props.addedProducts.find((e) => e.id == props.id) && "selected"}`}
        >
          <CardImgContainer>
            <CardImg
              className="object-fit-contain"
              src={imageUrl}
              alt={props.name}
            />
          </CardImgContainer>
          <div className="pt-2 d-flex flex-column row-gap-1">
            <CardProductCode>{props.sku}</CardProductCode>
            <CardProductName title={props.name}>{props.name}</CardProductName>
          </div>
        </Card>
      </div>
    </>
  ) : (
    <div className={`${props.isSelected ? "catalog-active" : ""}`}>
      <Link
        className="text-decoration-none row"
        to={props.carpenterView ? `${getCatalogsUrl()}` : `${props.id}`}
        state={props.searchValue}
        onClick={() => {
          props.onClick ? props.onClick(props.id) : null;
        }}
      >
        <div className="col-5">
          <ReactStrapCard className="my-3">
            <CardImgContainer className="d-flex justify-content-center">
              <CardImg
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                className="object-fit-contain"
                src={imageUrl}
                alt={props.name}
              />
            </CardImgContainer>
          </ReactStrapCard>
        </div>
        <div
          className="col-7 d-flex flex-column py-2"
          style={{ color: "black" }}
        >
          <span className="fw-bold" title={props.name}>
            {props.name}
          </span>
          <span style={{ fontSize: "13px", color: "gray" }}>
            {dimensions.height} H * {dimensions.width} W * {dimensions.depth} D
          </span>
          <h5>
            {!props.carpenterView && (
              <>
                <span style={{ color: "gray" }}>
                  &#8377;
                  {props.actualPrice &&
                    props.actualPrice.toLocaleString("en-IN")}
                </span>
                &nbsp;
                <span>
                  (&#8377;
                  {props.sqftPrice &&
                    props.sqftPrice.toLocaleString("en-IN")} / sq.ft)
                </span>
              </>
            )}
            <div className="d-flex flex-wrap mt-2" style={{ gap: "5px" }}>
              {props.tags.map((tag, index) => (
                <Button
                  key={index}
                  className="bg-light fs-12px"
                  style={{
                    color: "gray",
                    border: "1px solid darkgray",
                    padding: "2px",
                  }}
                >
                  {tag}
                </Button>
              ))}
            </div>
          </h5>
        </div>
      </Link>
    </div>
  );
};

export default Product;
